// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"4":"07a3b935","120":"86ac6472","856":"a606ea4f"}[chunkId] + ".js";
};